<template>
  <div class="template">
    <b-form-group
      :id="endpoint + '-template-subject'"
      label="Emne"
      :label-for="endpoint + '-template-subject-input'"
      description="Emnet for mailen"
    >
      <b-form-input
        :id="endpoint + '-template-subject-input'"
        v-model="template.subject"
        placeholder=""
        :disabled="loading"
      ></b-form-input>
    </b-form-group>
    <div class="mb-3">
      <label for="content">Indhold</label>
      <b-overlay :show="loading" variant="dark" :opacity="0.15" spinner-variant="primary">
        <editor
          :id="endpoint + '-template-content'"
          apiKey="bvtv0k3l32ywgtrypzpkaf1lcxq8lhg4uj4jjez261xz21jj"
          initialValue=""
          v-model="template.content"
          :init="{
            height: 500,
            menubar: false,
            theme: 'silver',
            skin_url: '/oxide',
            branding: false,
            invalid_elements: 'div',
            plugins: [
              'advlist autolink lists link image charmap',
              'searchreplace visualblocks code fullscreen',
              'print preview anchor insertdatetime media',
              'paste code help wordcount table',
              'visualblocks'
            ],
            toolbar:
              'undo redo visualblocks | formatselect | bold italic | \
              alignleft aligncenter alignright alignjustify | \
              bullist numlist outdent indent | help'
          }"
        ></editor>
      </b-overlay>
      <small class="form-text text-muted">{{ caption }}</small>
      <b-alert class="mt-3 mb-0" style="white-space: break-spaces;" :show="alert !== null" :variant="alertVariant">
        {{alert}}
      </b-alert>
      <b-overlay class="d-inline-block mt-3" :show="saving" variant="light" :opacity="0.5" spinner-variant="primary" spinner-small rounded="sm">
        <b-button variant="primary" @click="saveTemplate()" :disabled="loading || saving">Gem skabelonen</b-button>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
import tinymce from 'tinymce/tinymce'
import 'tinymce/themes/silver/theme'
import 'tinymce/icons/default'
import 'tinymce/plugins/advlist'
import 'tinymce/plugins/autolink'
import 'tinymce/plugins/lists'
import 'tinymce/plugins/link'
import 'tinymce/plugins/image'
import 'tinymce/plugins/charmap'
import 'tinymce/plugins/searchreplace'
import 'tinymce/plugins/visualblocks'
import 'tinymce/plugins/code'
import 'tinymce/plugins/fullscreen'
import 'tinymce/plugins/print'
import 'tinymce/plugins/preview'
import 'tinymce/plugins/anchor'
import 'tinymce/plugins/insertdatetime'
import 'tinymce/plugins/media'
import 'tinymce/plugins/paste'
import 'tinymce/plugins/code'
import 'tinymce/plugins/help'
import 'tinymce/plugins/wordcount'
import 'tinymce/plugins/table'
import 'tinymce/plugins/visualblocks'
export default {
  components: {
    Editor
  },
  props: {
    endpoint: {
      type: String,
      default: ''
    },
    caption: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    template: {
      subject: null,
      content: null
    },
    loading: true,
    saving: false,
    alert: null,
    alertVariant: 'danger',
  }),
  mounted() {
    this.axios.get('/api/newsletters/templates/' + this.endpoint, this.config).then((response) => {
      this.loading = false
      this.template.subject = response.data.data.summary_template
      this.template.content = response.data.data.body_template
    }).catch(error => {
      this.loading = false
      this.alert = 'Skabelonen kunne ikke hentes.\n\nFejlbesked: ' + error + '\n\nPrøv igen senere.'
      this.alertVariant = 'danger'
    })
    tinymce.init({
      invalid_elements : 'div'
    })
  },
  computed: {
    config() {
      return this.$store.getters.getConfig
    }
  },
  methods: {
    saveTemplate() {
      this.alert = null
      this.saving = true
      this.axios.put('/api/newsletters/templates/' + this.endpoint, {
        subject_template: this.template.subject,
        body_template: this.template.content
      }, this.config).then(() => {
        this.saving = false
        this.alert = 'Skabelonen blev gemt'
        this.alertVariant = 'success'
      }).catch(error => {
        this.saving = false
        this.alert = 'Der opstod en fejl:\n\nFejlbesked: ' + error + '\n\nPrøv igen senere.'
        this.alertVariant = 'danger'
      })
    }
  }
}
</script>

<style>

</style>